module.exports = __webpack_public_path__ + "img/341.e7579092.jpg";